import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import classnames from 'classnames';
import mapHandlers from "../hoc/map-handlers";
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import { Menu as UIMenu } from 'semantic-ui-react';
var UNSUPPORTED_PROPS = ['as', 'className', 'position' // unsupported until we have a use case for this
];
var ADDED_PROPS = ['isDivided', 'activeValue', 'onItemClick'];
var MenuSubmenu = createComponent({
  displayName: 'Submenu',
  propTypes: {
    children: PropTypes.node,
    isDivided: PropTypes.bool,
    activeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onItemClick: PropTypes.func
  },
  defaultProps: {
    children: null,
    isDivided: false,
    activeValue: null,
    onItemClick: null
  },
  render: function render(props) {
    var _context;

    var UIProps = toUIProps({
      props: props,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS
    });
    UIProps.className = classnames({
      divided: props.isDivided
    });
    delete UIProps.children;

    var children = _mapInstanceProperty(_context = React.Children).call(_context, props.children, function (child, idx) {
      return /*#__PURE__*/React.cloneElement(child, {
        activeValue: props.activeValue,
        onItemClick: props.onItemClick
      });
    });

    return /*#__PURE__*/React.createElement(UIMenu.Menu, UIProps, children);
  }
});
export var PrivateSubmenu = mapHandlers({
  itemClick: []
})(MenuSubmenu);
export default compose(removeProps(['onItemClick', 'activeValue']), whitelistStyles())(MenuSubmenu);
//# sourceMappingURL=menu-submenu.js.map